var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from "react";
import { useParams } from "react-router-dom";
import { useQuery, useQueryClient } from "react-query";
import { useOkapiKy, useCallout } from "@folio/stripes/core";
import { useIntl } from "react-intl";
import { LoadingPane, Pane } from "@folio/stripes/components";
import { fetchTitleById, updateTitle } from "../../api/titleService";
import TitleForm from "./TitleForm";
import { usePermissions } from "../../hooks/usePermissions";
import { useConsumeQueryParam } from "../../hooks/useConsumeQueryParam";
import { AccessDenied } from "../../components/AccessDenied";
import { sanitizeTitlePayload } from "../../utils/sanitizeTitlePayload";
import TitleProductsPanel, { ProductsPaneTitle, } from "../../components/title/TitleProductsPanel";
var TitleEdit = function () {
    var _a;
    var ky = useOkapiKy();
    var queryClient = useQueryClient();
    var callout = useCallout();
    var formatMessage = useIntl().formatMessage;
    var id = useParams().id;
    var canEditTitleItem = usePermissions().canEditTitleItem;
    // "Přidat produkt" navigates here with ?newProduct=1 to open the create modal.
    var autoOpenCreateProduct = useConsumeQueryParam("newProduct") === "1";
    var _b = useQuery(["title", id], function () { return fetchTitleById(ky, id); }, {
        staleTime: Infinity,
    }), title = _b.data, error = _b.error, isLoading = _b.isLoading, isError = _b.isError;
    if (isLoading)
        return React.createElement(LoadingPane, null);
    if (isError || !title) {
        return React.createElement("div", null,
            "Error: ", (_a = error === null || error === void 0 ? void 0 : error.message) !== null && _a !== void 0 ? _a : "title not found");
    }
    if (!canEditTitleItem(title)) {
        return React.createElement(AccessDenied, { showNavigation: true });
    }
    var handleSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var input, fresh;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    input = sanitizeTitlePayload(__assign(__assign({}, data), { id: (_b = (_a = data.id) !== null && _a !== void 0 ? _a : title === null || title === void 0 ? void 0 : title.id) !== null && _b !== void 0 ? _b : id, version: (_c = data.version) !== null && _c !== void 0 ? _c : title === null || title === void 0 ? void 0 : title.version }));
                    return [4 /*yield*/, updateTitle(ky, id, input)];
                case 1:
                    _d.sent();
                    return [4 /*yield*/, fetchTitleById(ky, id)];
                case 2:
                    fresh = _d.sent();
                    queryClient.setQueryData(["title", id], fresh);
                    callout === null || callout === void 0 ? void 0 : callout.sendCallout({
                        type: "success",
                        message: formatMessage({ id: "ui-br-agency.title.save.success" }),
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(TitleForm, { initialValues: title, onSubmit: handleSubmit, title: formatMessage({
            id: "ui-br-agency.title.edit.pane.title",
        }), detailPane: React.createElement(Pane, { id: "detailPane", defaultWidth: "35%", paneTitle: React.createElement(ProductsPaneTitle, { titleId: title.id }) },
            React.createElement(TitleProductsPanel, { title: title, autoOpenCreate: autoOpenCreateProduct })) }));
};
export default TitleEdit;
